// @core/api/endpoints/team/cancel_team_role_application.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CancelTeamRoleApplicationRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Cancel role application
 * Cancels a pending role change application. Only the original applicant can cancel their request.
 */
export async function CancelTeamRoleApplication(
  request_id: string,
  data: CancelTeamRoleApplicationRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/role-applications/:request_id/cancel`;
  requestPath = requestPath.replace(':request_id', encodeURIComponent(request_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
